import React, { useContext, useEffect, useState } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";
import ContextMenu from "./ContextMenu";
import "./Layers.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";

const Layers = ({ LayOut }) => {
  const {
    flatList,
    setSelectedDivision,
    selectedDivision,
    setHoveredDivision,
    deleteDivision,
    renameDivision,
    giveIdToDivision,
    makeReusable,
    reusableComponents,
    applyReusableComponent,
    deleteReusableComponent,
    renameReusableComponent,
    reorderDivision,
  } = useContext(CanvasContext);

  const [contextMenu, setContextMenu] = useState(null);
  const [search, setSearch] = useState("");

  const handleMoveUp = (e, id) => {
    e.stopPropagation();
    reorderDivision(id, "up");
  };

  const handleMoveDown = (e, id) => {
    e.stopPropagation();
    reorderDivision(id, "down");
  };

  const handleMouseEnter = (id) => {
    setHoveredDivision(id);
  };

  const handleMouseLeave = () => {
    setHoveredDivision(null);
  };

  const handleContextMenu = (e, division) => {
    e.preventDefault();
    setContextMenu({
      position: { x: e.clientX, y: e.clientY },
      division,
    });
  };

  const handleRename = (classname) => {
    if (contextMenu?.division?.id) {
      renameDivision(contextMenu.division.id, classname);
      setContextMenu(null);
    }
  };

  const handleIdChange = (IDNAME) => {
    if (contextMenu?.division?.id) {
      giveIdToDivision(contextMenu.division.id, IDNAME);
      setContextMenu(null);
    }
  };

  const handleDelete = () => {
    deleteDivision(contextMenu.division.id);
    setContextMenu(null);
  };

  const handleReusableComponentContextMenu = (e, component) => {
    e.preventDefault();
    setContextMenu({
      position: { x: e.clientX, y: e.clientY },
      component,
      isReusable: true,
    });
  };
  const handleRenameReusableComponent = (newName) => {
    if (contextMenu?.component?.id) {
      renameReusableComponent(contextMenu.component.id, newName);
      setContextMenu(null);
    }
  };

  const handleDeleteReusableComponent = () => {
    if (contextMenu?.component?.id) {
      deleteReusableComponent(contextMenu.component.id);
      setContextMenu(null);
    }
  };

  const handleApplyReusableComponent = () => {
    if (contextMenu?.component) {
      applyReusableComponent(contextMenu.component);
      setContextMenu(null);
    }
  };

  const handleMakeReusable = () => {
    if (contextMenu?.division) {
      makeReusable(contextMenu.division);
      setContextMenu(null);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Check if the Ctrl key is pressed along with the Delete key
      if (e.key === "Delete" && e.ctrlKey && selectedDivision !== null) {
        deleteDivision(selectedDivision);
        setSelectedDivision(null);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedDivision, deleteDivision, setSelectedDivision]);

  return (
    <div className="layers-container">
      <h3>Layers</h3>
      <div className="SearchBar">
        <input
          type="text"
          placeholder="Search Here!"
          onChange={(e) => {
            setSearch(e.target.value);
          }}
        />
      </div>
      <ol className="layers-list">
        {flatList
          .filter((item) => {
            const Name = `${item.classname || item.name}(ID:${item.id})`;
            return search.toLowerCase() === ""
              ? item
              : Name.toLowerCase().includes(search);
          })
          .map((division) => (
            <li
              key={division.id}
              className={`layer-item ${
                selectedDivision === division.id ? "selected" : ""
              }`}
              onClick={() => {
                setSelectedDivision(division.id);
              }}
              onMouseEnter={() => handleMouseEnter(division.id)}
              onMouseLeave={handleMouseLeave}
              onContextMenu={(e) => handleContextMenu(e, division)}
            >
              <div className="layer-item-content">
                <span>
                  {division.classname ? division.classname : division.name} (ID:
                  {division.id})
                </span>
                <div className="layer-item-buttons">
                  <button onClick={(e) => handleMoveUp(e, division.id)}>
                    <FontAwesomeIcon icon={faArrowUp} />
                  </button>
                  <button onClick={(e) => handleMoveDown(e, division.id)}>
                    <FontAwesomeIcon icon={faArrowDown} />
                  </button>
                </div>
              </div>
            </li>
          ))}
      </ol>
      <h3 style={{ textAlign: "center", marginTop: "10px" }}>
        Reusable Components
      </h3>
      {reusableComponents.length === 0 ? (
        <p
          style={{
            textAlign: "left",
            backgroundColor: "#F4E00B",
            padding: "3px",
          }}
        >
          Right click on any component then make it reusable.
        </p>
      ) : (
        <ol className="reusable-components-list">
          {reusableComponents.map((component) => (
            <li
              key={component.id}
              className="reusable-component-item"
              onClick={() => applyReusableComponent(component)}
              onContextMenu={(e) =>
                handleReusableComponentContextMenu(e, component)
              }
            >
              {component.name}
            </li>
          ))}
        </ol>
      )}
      {contextMenu && (
        <ContextMenu
          onRename={
            contextMenu.isReusable
              ? handleRenameReusableComponent
              : handleRename
          }
          onIdChange={handleIdChange}
          onDelete={
            contextMenu.isReusable
              ? handleDeleteReusableComponent
              : handleDelete
          }
          onMakeReusable={
            contextMenu.isReusable
              ? handleApplyReusableComponent
              : handleMakeReusable
          }
          onClose={() => setContextMenu(null)}
          divisionName={
            contextMenu.division?.name ||
            contextMenu.component?.name ||
            "Unnamed"
          }
          divisionId={
            contextMenu.division?.id || contextMenu.component?.id || "Unnamed"
          }
          divisionIdForHtml={contextMenu.division?.Id_For_html || ""}
          LayOut={LayOut}
          isReusable={contextMenu.isReusable}
        />
      )}
    </div>
  );
};

export default Layers;
